import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import brand from "../images/Icons/brand.png";
import placeImage from "../images/placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import { fetchBrand } from "../redux/slice/brand";

export default function Brands() {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 8,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 5,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 2,
      slidesToSlide: 1,
    },
  };

  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  const dispatch = useDispatch();
  const { brandData, isError } = useSelector((state) => state.brand);

  useEffect(() => {
    if (!isError) {
      dispatch(fetchBrand());
    }
  }, [dispatch, isError]);

  if (brandData.length > 0) {
    return (
      <>
        <div className="container-fluid">
          <div className="showcase-product mrty1">
            <div className="row-hd-txt">
              <div className="row-hd-txt-left">
                <img src={brand} alt="icon" />
                <h5>Brands Associated With Us</h5>
              </div>
            </div>

            <div className="brand-slider-area">
              <Carousel
                responsive={responsive}
                swipeable={true}
                draggable={true}
                infinite={true}
                showDots={false}
                autoPlay={true}
                autoPlaySpeed={3000}
                removeArrowOnDeviceType={["mobile", "tablet", "desktop"]}
              >
                {brandData.map((brand, index) => (
                  <div className="brand-item" key={index}>
                    <img
                      src={brand.thumbnail}
                      onError={imageOnError}
                      alt={brand.name}
                    />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return;
  }
}
